const serials_request = (state = [], action) => {
  switch (action.type) {
    case "SET_SERIALS_REQUEST":
      return action.payload;
    default:
      return state;
  }
};

export default serials_request;
